var __jsx = React.createElement;
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { PageLayout } from "../../util/constants";
import { useRouter } from "next/router";
var HappyHour = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.HappyHour;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var HappyHourPage = function HappyHourPage() {
  var _store$common, _router$query, _store$common2;
  var store = useStore();
  var router = useRouter();
  var brandCodeDesc = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 || (_store$common = _store$common.concept) === null || _store$common === void 0 ? void 0 : _store$common.conceptCodeDesc;
  var _useState = useState(""),
    title = _useState[0],
    setTitle = _useState[1];
  var restaurantNumber = router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.setRestaurant;
  var conceptCode = store === null || store === void 0 || (_store$common2 = store.common) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.appAttributes) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.concept) === null || _store$common2 === void 0 ? void 0 : _store$common2.conceptCode;
  useEffect(function () {
    var getPageTitle = function getPageTitle() {
      return brandCodeDesc ? "Happy Hour | ".concat(brandCodeDesc) : "Happy Hour";
    };
    setTitle(getPageTitle());
  }, [brandCodeDesc]);
  React.useEffect(function () {
    var _store$user;
    store === null || store === void 0 || store.initComponent("HappyHour").then()["catch"](function (error) {
      //
    });
    store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || (_store$user = _store$user.analyticsModel) === null || _store$user === void 0 || _store$user.dispatchPageViewEvent();
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, title), conceptCode ?
  // For now, we’re using PD references, but in the future we’ll merge HH and PD into a shared React CSS reference.
  __jsx("link", {
    rel: "stylesheet",
    href: "/pd/css/".concat(conceptCode === null || conceptCode === void 0 ? void 0 : conceptCode.toLocaleLowerCase(), "_PD.css")
  }) : null), __jsx(HappyHour, {
    restaurantNumber: restaurantNumber
  }));
};
HappyHourPage.layout = PageLayout.NB_LAYOUT;
export default observer(HappyHourPage);